<template>
    <div>
        <v-card>
            <v-alert class="mt-12" color="primary" dark border="left">
                LIBRO VIRTUAL DE INTELIGENIO
            </v-alert>
        </v-card>

        <v-card>
            <v-card-text>
                <v-row dense>
                    <v-col col="12" class="d-flex align-center">

                        <ButtonComp class="mx-2" textButton="Volver" iconBut="mdi-arrow-left" classColor="red"
                            @click="goBack" normalButton />

                        <v-btn v-if="dataLogin.id_perfil == 2" color="primary" class="white--text"
                            @click="fillDataEsudiante">
                            <v-icon left>
                                fa-solid fa-upload
                            </v-icon>
                            Cargar archivos
                        </v-btn>

                        <v-spacer></v-spacer>

                        <v-btn v-if="dataLogin.licencia_perfil != 'estudiante'" color="primary" class="mx-3"
                            @click="resetBtn">
                            <v-icon left>
                                fas fa-sync-alt
                            </v-icon>
                            resetear
                        </v-btn>



                        <v-autocomplete class="my-select" label="Grado" v-model="bookGradoSelect" :items="filteredGrados"
                            item-text="desc_grado" @change="filtrarGrado" auto-select-first></v-autocomplete>
                    </v-col>


                </v-row>

                <!-- Modal para seleccionar el Nivel, grado y el Área -->
                <ComunDialogComp v-model="showModal" @close-modal="showModal = false" title="Información del Libro"
                    maxWidth="600">

                    <template v-slot:body>
                        <v-select label="Nivel" v-model="bookNivel" :items="listBookNivel" item-text="desc_nivel"
                            item-value="id_nivel" :disabled="true" :rules="[rul.required]"></v-select>

                        <v-select label="Grado" v-model="bookGrado" :items="filteredGrados" item-text="desc_grado"
                            :rules="[rul.required]"></v-select>

                        <v-select label="Área del Libro" v-model="bookArea" :items="listBookArea" item-text="desc_area"
                            :rules="[rul.required]"></v-select>

                    </template>
                    <template v-slot:actions>
                        <v-spacer></v-spacer>
                        <ButtonComp class="mx-2" @click="triggerFileUpload" textButton="Confirmar" />
                        <ButtonComp @click="showModal = false" textButton="Cancelar" classColor="red" />
                    </template>

                </ComunDialogComp>


                <!-- Campo de archivo oculto para cargar los archivos -->
                <input ref="fileInput" type="file" webkitdirectory directory multiple @change="handleFileUpload"
                    style="display: none;" />
                <!-- renderizado de la barra de carga -->

                <!-- <v-progress-linear v-if="chargingBarProgress" :value="uploadProgress" indeterminate></v-progress-linear> -->

                <v-col v-if="dataLogin.id_perfil == 2 && chargingBarProgress">
                    <!-- Barra de progreso total -->
                    <v-progress-linear :value="uploadProgress" color="light-blue" class="pb-3" height="14" striped>
                        <strong>{{ Math.round(uploadProgress) }}%</strong>
                    </v-progress-linear>

                    <v-row justify="center" class="mt-5">
                        <!-- Mostrar el conteo de archivos cargados frente al total -->
                        <p>{{ uploadedFiles }} / {{ totalFiles }} Archivos cargados</p>
                    </v-row>
                </v-col>

            </v-card-text>
        </v-card>

        <v-row v-if="filteredBooks.length > 0" class="gap-3 d-flex mt-8 justify-center">

            <router-link v-for="(level, index) in filteredBooks" :key="index"
                :to="{ name: 'libroVirtualVista', params: { level: level.area, book: filteredBooks } }"
                class="router-link ml-5">
                <v-card width="250" class="my-card rounded-lg elevation-10 mb-7">
                    <!-- <iframe style=""  name="simuladoresphet" height="300" width="100%"  frameborder="0" src="https://s3-inteligenio-test.s3.amazonaws.com/recurso/libroVirtual/primaria_3er_grado_educacionReligiosa/flipbook.pdf-thumb.jpg" ></iframe> -->
                    <!-- baseUrl + '/' + level.path_portada -->
                    <img :src="getImageUrl(level.path_portada)" @error="handleImageError($event, level.path_portada)"
                        height="300" width="100%" alt="Imagen no disponible">
                    <v-card-title class="d-flex justify-center py-3">{{ level.area }}</v-card-title>
                    <v-card-subtitle class="d-flex justify-center pb-2">{{ level.desc_grado }}</v-card-subtitle>
                </v-card>
            </router-link>
        </v-row>
        <v-row v-else class="d-flex mt-8 justify-center">
            <v-col cols="12">
                <v-card outlined>
                    <v-card-text>
                        <div class="d-flex justify-center text-h6  align-center" style="height: 320px">
                            No se han cargado libros para mostrar
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>
<script>
import axios, { API_URL, BUCKET_ORIGIN_SPACE } from "@/helpers/axios";
import { mapState } from 'vuex';
import ComunDialogComp from '../../../components/ComponentsEst/ComunDialogComp.vue';
import ButtonComp from '../../../components/ComponentsEst/TableButtonComp.vue';




export default {

    components: {
        ComunDialogComp,
        ButtonComp
    },

    data: () => ({
        educationalLevels: [
            {
                title: 'Educación religiosa',
                nivel: 'Primaria',
                grado: '3er grado',
                resources: [
                    {
                        // iframeSrc: 'https://s3-inteligenio-test.s3.amazonaws.com/recurso/libroVirtual/Primaria/3er_Grado/EducacionReligiosa/Catolica/flipbook.pdf-thumb.jpg',
                        iframeSrc: 'https://s3-inteligenio-test.s3.amazonaws.com/recurso/libroVirtual/Primaria/3er grado/Personal Social/Book/flipbook.pdf-thumb.jpg',
                        description: 'DescripciÃ³n del recurso 1 para Inicial'
                    },

                ]
            },
            {
                title: 'Personal social',
                nivel: 'Primaria',
                grado: '3er grado',
                resources: [
                    {
                        iframeSrc: 'https://s3-inteligenio-test.s3.amazonaws.com/recurso/libroVirtual/Primaria/3er_Grado/PersonalSocial/flipbook.pdf-thumb.jpg',
                        description: 'DescripciÃ³n del recurso para Primaria'
                    },

                ]
            },
            // {
            //     title: 'Ciencia y tecnología',
            //     nivel:'Primaria',
            //     grado:'3er grado',
            //     resources: [
            //         { 
            //             iframeSrc: 'https://s3-inteligenio-test.s3.amazonaws.com/recurso/libroVirtual/Primaria/3er_Grado/CienciaTecnologia/flipbook.pdf-thumb.jpg',
            //             description: 'DescripciÃ³n del recurso 1 para Secundaria'
            //         },

            //     ]
            // },
            {
                title: 'Matemática',
                nivel: 'Primaria',
                grado: '3er grado',
                resources: [
                    {
                        iframeSrc: 'https://s3-inteligenio-test.s3.amazonaws.com/recurso/libroVirtual/Primaria/3er_Grado/Matematica/flipbook.pdf-thumb.jpg',
                        description: 'Descripción del recurso 1 para Secundaria'
                    },

                ]
            },
            {
                title: 'Comunicación',
                nivel: 'Primaria',
                grado: '3er grado',
                resources: [
                    {
                        iframeSrc: 'https://s3-inteligenio-test.s3.amazonaws.com/recurso/libroVirtual/Primaria/3er_Grado/Comunicacion/flipbook.pdf-thumb.jpg',
                        description: 'DescripciÃ³n del recurso 1 para Secundaria'
                    },

                ]
            },
        ],
        defaultImageUrl: 'https://s3-inteligenio-beta.s3.amazonaws.com/recurso/libroVirtual/Img_no_disponible/NO+DISPONIBLE.png',
        estudianteResponse: [],
        showModal: false,
        listBookNivel: [],
        listBookGrado: [],
        listBookArea: [],
        familiarGrados: [],
        books: [],
        filteredBooks: [],
        bookNivel: '',
        bookGrado: '',
        bookGradoSelect: '',
        bookArea: '',
        filteredGrados: [],
        rul: {
            required: (value) => !!value || "Campo Requerido",
        },
        dataLogin: sessionStorage,
        baseUrl: BUCKET_ORIGIN_SPACE,
        totalFiles: 0,
        uploadedFiles: 0,
        uploadProgress: 0,
        chargingBarProgress: false,

    }),


    mounted() {
        this.preLoadQueryData();

    },

    computed: {
        ...mapState('globals', ['id_colegio', 'id_usuario']),
        logoColegio() {
            return (this.rutaServer + this.rutaLogo + this.editedItem.logo_colegio)
        },




        estudianteData() {

            // Intenta obtener los datos de la ruta, si no hay, utiliza localStorage
            let data = this.$route.params.estudianteData;
            if (!data || data.level == undefined) {
                // Intenta leer desde localStorage
                const storedData = localStorage.getItem('libroVirtualParams');

                if (storedData) {
                    data = JSON.parse(storedData);
                }
            }
            return { level: this.$route.params.level, estudianteData: data };
        },

        // gradosSelectFilter() {
        //     let rol = this.dataLogin.licencia_perfil;
        //     if (!this.bookGradoSelect || rol == 'webmaster') {
        //         // Si bookGrado está vacío, devuelve todos los libros
        //         return this.books;
        //     } else {
        //         // Filtra los libros según el grado seleccionado

        //         return this.books.filter(e => e.desc_grado == this.bookGradoSelect)
        //     }

        // },
    },

    methods: {

        async handleFileUpload(event) {
            try {


                const files = event.target.files;

                // Variables para el modal del proceso de carga de archivos
                this.totalFiles = files.length;
                this.uploadedFiles = 0; // Resetea el contador de archivos cargados
                this.uploadProgress = 0;
                this.individualFileProgress = new Array(files.length).fill(0); // Inicializa el progreso individual de cada archivo


                // for (let i = 0; i < files.length; i++) {
                //     const file = files[i];

                //     const formData = new FormData();
                //     formData.append('subirArchivo[]', file);
                //     formData.append('filePath[]', file.webkitRelativePath);
                const formData = new FormData();

                for (const file of files) {

                    formData.append('subirArchivo[]', file);
                    formData.append('filePath[]', file.webkitRelativePath);
                }


                let params = {
                    bookNivel: this.bookNivel,
                    bookGrado: this.bookGrado,
                    bookArea: this.bookArea,
                };
                formData.append('myDataKey', JSON.stringify(params));

                // metodo que recibe actualizaciones sobre el progreso de la carga de archivos
                // const config = {
                //     onUploadProgress: progressEvent => {
                //         let progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                //         this.individualFileProgress[i] = progress; // Actualiza el progreso del archivo individual
                //         this.uploadProgress = this.individualFileProgress.reduce((a, b) => a + b, 0) / this.totalFiles; // Calcula el progreso total
                //     }
                // };

                // , config
                await axios.post("/libroVirtual/s3Upload", formData);


                this.uploadedFiles++; // Incrementa el contador de archivos cargados

                const eventSource = new EventSource(`${API_URL}eventEmitters/charginBarStatus`, { withCredentials: true });

                eventSource.onopen = () => {
                    console.log('Conexión establecida con el servidor de eventos');
                };

                eventSource.onerror = (error) => {
                    console.error('Error en la conexión con el servidor de eventos:', error);
                };
                // Proceso de eventos aquí

                eventSource.onmessage = (event) => {
                    console.log('Mensaje recibido:', event.data);
                    // Aquí puedes procesar los datos de progreso recibidos del servidor
                    let data = JSON.parse(event.data);
                    if (data.progress) {
                        this.uploadProgress = data.progress;
                        this.uploadedFiles = Math.floor(data.progress / 100 * this.totalFiles);
                    }
                    // También puedes actualizar la barra de progreso aquí
                    // this.uploadProgress = calcularProgresoDesdeData(data); // Puedes definir esta función según el formato de los datos recibidos
                };

                eventSource.onmessage = (event) => {
                    console.log('Mensaje recibido:', event.data);
                    // Aquí puedes procesar los datos de progreso recibidos del servidor
                    let data = JSON.parse(event.data);
                    if (data.progress) {
                        this.uploadProgress = data.progress;
                        this.uploadedFiles = Math.floor(data.progress / 100 * this.totalFiles);
                    }
                };
                console.log(eventSource);
                // } 
                // Restablece el progreso después de cargar todos los archivos
                setTimeout(() => {
                    this.uploadProgress = 0;
                    this.uploadedFiles = 0;
                    this.totalFiles = 0;
                    this.individualFileProgress = [];
                    this.chargingBarProgress = false;
                }, 3000);
            } catch (error) {
                console.error('Error al subir archivos:', error);
            }
        },

        goBack() {
            this.$router.push({ name: 'Libro virtual' });
        },

        async filtrarGrado() {
            this.filteredBooks = this.books.filter(e => e.desc_grado == this.bookGradoSelect);
        },

        getImageUrl(path) {
            // Concatena la base URL con el path de la imagen
            return `${this.baseUrl}/${path}`;
        },

        handleImageError(event, path) {
            // Reemplaza la fuente de la imagen con la imagen por defecto
            // Solo si la imagen actual no es ya la imagen por defecto
            if (event.target.src !== this.defaultImageUrl) {
                console.error(`Error al cargar la imagen: ${path}`);
                event.target.src = this.defaultImageUrl;
            }
        },


        async getBooks() {

            let formatId = this.listBookNivel[0].id_nivel;
            let queryBooks = await axios.get(`/libroVirtual/getBooks/${formatId}`);
            this.books = queryBooks.data;

            let rol = this.dataLogin.licencia_perfil;
            if (rol == 'estudiante') {
                this.filteredBooks = this.books.filter(e => parseInt(e.id_grado) == parseInt(this.estudianteData.estudianteData.estudianteData.id_grado_clickone))
            } else if (rol == 'familiar') {
                let childrenfamiliar = await axios.get(`/libroVirtual/getFamiliar/` + this.dataLogin.id)
                this.familiarGrados = childrenfamiliar.data
                let familiarGradosfilter = this.familiarGrados

                this.filteredBooks = this.books.filter(book => {
                    return familiarGradosfilter.some(grado => parseInt(book.id_grado) === parseInt(grado.id_grado_clickone));
                });
                this.books = this.filteredBooks

                let gradosByNivel = this.listBookGrado.filter(e => {
                    return parseInt(e.id_nivel_clickone) === parseInt(this.listBookNivel[0].id_nivel) &&
                        familiarGradosfilter.some(grado => parseInt(e.ck1id) === parseInt(grado.id_grado_clickone));
                });




                this.filteredGrados = gradosByNivel.sort((a, b) => a.desc_grado.localeCompare(b.desc_grado));
                // console.log(this.familiarGrados, 'Estos son los grados de familiares');



            } else {
                this.filteredBooks = this.books;
                console.log('No reconoce que es estudiante');
            }
            return this.filteredBooks;

        },

        async fillDataEsudiante() {
            this.limpiarData();
            this.showModal = true;
            this.listBookNivel = [this.estudianteData.estudianteData.level];
            this.bookNivel = this.listBookNivel[0].id_nivel
        },

        async triggerFileUpload() {
            // Cierra el modal
            this.showModal = false;
            // Muestra el proceso de la barra de carga
            this.chargingBarProgress = true;
            // Restablece el valor del input para asegurar que el evento change se dispare incluso si se selecciona el mismo archivo
            this.$refs.fileInput.value = ''
            // Desencadena la selección de archivos
            this.$refs.fileInput.click();
        },

        async filterbookGrados() {
            let rol = this.dataLogin.licencia_perfil;
            if (rol == 'webmaster' || rol == 'null') {
                let gradosByNivel = this.listBookGrado.filter(e =>
                    parseInt(e.id_nivel_clickone) === parseInt(this.estudianteData.estudianteData.level.id_nivel));
                this.filteredGrados = gradosByNivel.sort((a, b) => a.desc_grado.localeCompare(b.desc_grado));

            } else {
                let gradosByNivel = this.listBookGrado.filter(e =>
                    parseInt(e.id_nivel_clickone) === parseInt(this.estudianteData.estudianteData.level.id_nivel)
                    && parseInt(e.ck1id) === parseInt(this.estudianteData.estudianteData.estudianteData.id_grado_clickone));
                this.filteredGrados = gradosByNivel.sort((a, b) => a.desc_grado.localeCompare(b.desc_grado));
            }



        },

        async preLoadQueryData() {

            try {
                let queryGrados = await axios.get('/libroVirtual/gradoName')
                let queryAreas = await axios.get('/libroVirtual/areaName')
                this.listBookNivel = [this.estudianteData.estudianteData.level];
                this.listBookGrado = queryGrados.data;
                let queryBookArea = queryAreas.data;
                this.listBookArea = queryBookArea.sort((a, b) => a.desc_area.localeCompare(b.desc_area));
                this.getBooks();
                this.filterbookGrados();

            } catch (error) {
                console.error("Hubo un error al cargar los datos: ", error);
            }
        },

        async limpiarData() {
            this.bookGrado = '';
            this.bookArea = '';
            this.bookGradoSelect = '';
        },

        async resetBtn() {
            this.limpiarData();
            this.filteredBooks = this.books;
            // this.gradosSelectFilter();
        },
    },
};
</script>



<style scoped>
.my-card {
    transition: transform 0.3s ease;
    cursor: pointer;
    /* border: 2px solid red; */
}

.my-card:hover {
    transform: scale(1.05);
}

.router-link {
    text-decoration: none;
}

.my-select {
    max-width: 250px;
}
</style>